'use client';

import { useState, useEffect } from 'react';
import { getActiveSeasonalPeriod } from '@/lib/seasonal-movies';
import type { SeasonalLogo, SeasonalPeriod } from '@/lib/seasonal-movies';

export function useSeasonalLogo() {
  const [seasonalLogo, setSeasonalLogo] = useState<SeasonalLogo | null>(null);
  const [seasonalTheme, setSeasonalTheme] = useState<SeasonalPeriod | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSeasonalLogo = async () => {
      try {
        const activePeriod = await getActiveSeasonalPeriod();
        if (activePeriod) {
          setSeasonalTheme(activePeriod);
          if (activePeriod.logo) {
            setSeasonalLogo(activePeriod.logo);
          } else {
            setSeasonalLogo(null);
          }
        } else {
          setSeasonalLogo(null);
          setSeasonalTheme(null);
        }
      } catch (error) {
        setSeasonalLogo(null);
        setSeasonalTheme(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSeasonalLogo();
  }, []);

  // Get the primary theme color (first color in the array, or fallback to red)
  const themeColor = seasonalTheme?.colors?.[0] || '#dc2626'; // red-600 as fallback

  return { seasonalLogo, seasonalTheme, themeColor, loading };
}
